<template>
    <div class="content-box">
      <div class="about-main">
<!--        <div class="about-menu box">-->
<!--            <ul>-->
<!--                <li>关于我们</li>-->
<!--                <li><router-link to="/about" href="about.html">平台介绍</router-link></li>-->
<!--&lt;!&ndash;                <li><router-link to="/contact" href="contact.html">联系我们</router-link></li>&ndash;&gt;-->
<!--&lt;!&ndash;                <li><router-link to="/legaldec" href="help.html">法律声明</router-link></li>&ndash;&gt;-->
<!--            </ul>-->
<!--        </div>-->

        <div class="about-content">
         <router-view></router-view>
        </div>
      </div>

    </div>
</template>

<script>
    export default {
        name: "Index"
    }
</script>

<style scoped>

</style>
